

































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import CreateLocationWorkerRequest from "@/models/LocationWorkers/CreateLocationWorkerRequest";
import ListUtils from "@/lib/listUtils";

@Component({
  name: "WorkerLocationCreate",
})
export default class extends GiganautVueDialog {

public request = new CreateLocationWorkerRequest();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new CreateLocationWorkerRequest();
      this.request.workerId = WorkerDetailsModule.currentWorker.id;
      if (this.locations.length == 0) {
        await WorkerDetailsModule.getLocations();
      }
    }
  }

  get locations() {
    return WorkerDetailsModule.locations;
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get types() {
    return ListUtils.locationWorkerTypes();
  }

  async save() {
    await WorkerDetailsModule.createLocationWorker(this.request);
    this.dialog = false;
  }
}
